import { resolveInterventionApprovalLetterFollowUp } from './interventionStatus';

const sameId = (a, b) => a != null && b != null && String(a) === String(b);
export function interventionLetterOptions(plans, primaryId) {
  const plan = (plans || []).find(plan => (plan.interventions || []).some(row => sameId(row.id, primaryId)));
  return (plan?.interventions || []).filter(row => {
    if (sameId(row.id, primaryId) || !row.approvalVersion || row.isAppliedRevisionEvidence || row.metadata?.revision?.sourceInterventionId) return false;
    const followUp = resolveInterventionApprovalLetterFollowUp(row);
    return followUp.eligible && followUp.pendingLetter;
  }).map(row => ({ value: String(row.id), label: row.title || `Intervention ${row.code || row.id}`, record: row }));
}

export function defaultInterventionLetterSelections(primary, options) {
  const metadata = primary?.metadata || {};
  const appealId = metadata.lastAppliedRevision?.appealId;
  if (appealId) return options.filter(option => sameId(option.record.metadata?.lastAppliedRevision?.appealId, appealId));
  if (metadata.lastAppliedRevision || metadata.approvalMaterialization) return [];
  const itemIds = new Set((metadata.proposedInterventions || []).map(item => String(item.id)));
  return options.filter(option => {
    const child = option.record.metadata || {};
    return !child.lastAppliedRevision && sameId(child.approvalMaterialization?.sourceInterventionId, primary?.id) &&
      itemIds.has(String(child.approvalMaterialization?.sourceItemId));
  });
}

export function interventionLetterCoverage(primary, selected) {
  if (!primary?.id || !primary.approvalVersion) return [];
  return [{ interventionId: Number(primary.id), approvalVersion: primary.approvalVersion },
    ...selected.map(option => ({ interventionId: Number(option.value), approvalVersion: option.record.approvalVersion }))]
    .sort((a, b) => a.interventionId - b.interventionId);
}

// Operational records are one service each, even when the primary retains the
// complete original proposal array. Never duplicate children from that array.
export function interventionLetterDraftItems(primary, selected, fallbackItems = []) {
  const fromRecord = (row, fallback) => {
    const metadata = row?.metadata || {};
    const snapshot = metadata.snapshot || {};
    const original = metadata.proposedInterventions?.[0] || fallback || {};
    return { ...original, ...snapshot,
      id: row?.id || original.id, title: row?.title || snapshot.title || original.title,
      code: row?.code ?? snapshot.code ?? original.code,
      startDate: row?.startDate ?? snapshot.startDate ?? original.startDate,
      endDate: row?.endDate ?? snapshot.endDate ?? original.endDate,
      costLines: row?.costLines || metadata.costLines || snapshot.costLines || original.costLines || [],
    };
  };
  return [fromRecord(primary, fallbackItems[0]), ...selected.map(option => fromRecord(option.record))];
}
